import { Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useMusicGate } from '@/context/MusicGateContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_07dd2ee2-42aa-4d8a-a966-79b38cca8e94/artifacts/skr2sta7_Logo.png";

export const MusicGate = () => {
    const { unlocked, unlock } = useMusicGate();

    if (unlocked) return null;

    return (
        <div
            data-testid="music-gate-overlay"
            className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-bg/95 backdrop-blur-md"
        >
            {/* Smoke effects */}
            <div className="absolute bottom-0 left-1/4 smoke-effect animate-smoke" style={{ animationDelay: '0s' }} />
            <div className="absolute bottom-0 right-1/3 smoke-effect animate-smoke" style={{ animationDelay: '2s' }} />
            <div className="absolute bottom-0 left-1/2 smoke-effect animate-smoke" style={{ animationDelay: '4s' }} />

            <div className="relative z-10 text-center px-6 max-w-xl">
                <img
                    src={LOGO_URL}
                    alt="StillFaded"
                    className="w-40 md:w-48 mx-auto mb-8 animate-float"
                />
                <p className="font-mono text-xs text-brand-primary uppercase tracking-widest mb-4">
                    ENTER THE VIBE
                </p>
                <h2 className="font-syne font-extrabold text-4xl md:text-6xl text-white tracking-tighter uppercase mb-6">
                    FADED KEENAN
                </h2>
                <p className="font-space text-slate-400 text-base md:text-lg mb-10">
                    Press play to start the soundtrack. Smoke optional.
                </p>
                <Button
                    data-testid="music-gate-play-btn"
                    onClick={unlock}
                    className="bg-white text-black hover:bg-slate-200 rounded-none px-10 py-7 font-bold uppercase tracking-widest text-base"
                >
                    <Play className="w-5 h-5 mr-3 fill-black" /> PLAY MUSIC
                </Button>
                <button
                    data-testid="music-gate-skip-btn"
                    onClick={unlock}
                    className="block mx-auto mt-6 font-mono text-xs text-slate-500 hover:text-white uppercase tracking-widest transition-colors"
                >
                    Or just enter the site →
                </button>
            </div>
        </div>
    );
};
